/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pure_Mild_Wolf_LiftInputs */

const en_pure_mild_wolf_lift = /** @type {(inputs: Pure_Mild_Wolf_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const de_pure_mild_wolf_lift = /** @type {(inputs: Pure_Mild_Wolf_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Pure_Mild_Wolf_LiftInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pure_mild_wolf_lift = /** @type {((inputs?: Pure_Mild_Wolf_LiftInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pure_Mild_Wolf_LiftInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pure_mild_wolf_lift(inputs)
	return de_pure_mild_wolf_lift(inputs)
});